import { Container, Row, Col } from 'react-bootstrap';
import { Clock, MapPin, Calendar, Users, BarChart, Download, Smartphone, Headphones, Camera, Palmtree } from 'lucide-react';

function PackageFeatures() {

    const features = [
        {
            icon: Clock,
            title: "Ewidencja czasu pracy",
            description: "Pełne zestawienie przepracowanych godzin w jednym miejscu."
        },
        {
            icon: MapPin,
            title: "GPS",
            description: "Weryfikacja obecności pracowników w miejscu pracy."
        },
        {
            icon: Calendar,
            title: "Grafik i zmiany",
            description: "Planowanie zmian i obecności w zespole, widoczne w aplikacji mobilnej."
        },
        {
            icon: Users,
            title: "Lista obecności",
            description: "Aktualna lista osób na zmianie, zawsze pod ręką."
        },
        {
            icon: BarChart,
            title: "Raporty i analityka",
            description: "Dane o godzinach, kosztach i efektywności zespołu."
        },
        {
            icon: Download,
            title: "Eksport do PDF i Excel",
            description: "Gotowe raporty do rozliczeń, faktur i działu kadr."
        },
        {
            icon: Camera,
            title: "Notatka ze zdjęciem",
            description: "Pełna dokumentacja wykonanych prac."
        },
        {
            icon: Palmtree,
            title: "Wnioski urlopowe",
            description: "Składanie i zatwierdzanie wniosków urlopowych online z automatycznym naliczaniem dni wolnych."
        },
        {
            icon: Smartphone,
            title: "Aplikacja mobilna",
            description: "Szybki dostęp do grafiku i czasu pracy z telefonu."
        },
        {
            icon: Headphones,
            title: "Wsparcie techniczne i wdrożeniowe",
            description: "Pomoc przy starcie oraz bieżące wsparcie naszego zespołu."
        }
    ];

    return (
        <Container fluid style={{ backgroundColor: '#F8F9FC', padding: '80px 20px' }}>
            <Container>
                <Row className='mb-4'>
                    <Col className='text-center'>
                        <h2 style={{ 
                            fontSize: '2.25rem', 
                            fontWeight: '700', 
                            color: '#262A33',
                            marginBottom: '16px'
                        }}>
                            Wszystkie funkcje dostępne w eGodzinach:
                        </h2>
                        <p style={{
                            fontSize: '1.125rem',
                            color: '#6B7280',
                            maxWidth: '800px',
                            margin: '0 auto',
                            lineHeight: '1.7'
                        }}>
                            Część z nich jest w standardzie, inne możesz włączyć jako dodatkowe moduły. Zakres dopasowany do Twojej firmy.
                        </p>
                    </Col>
                </Row>

                <Row className='mt-5 justify-content-center'>
                    {features.map((feature, index) => {
                        const IconComponent = feature.icon;
                        return (
                            <Col key={index} xs={12} sm={6} lg={4} xl={3} className='mb-4'>
                                <div className='package-feature-card'>
                                    <div className='package-icon-wrapper'>
                                        <IconComponent 
                                            size={32} 
                                            strokeWidth={1.5}
                                            style={{ color: '#3A6DFF' }}
                                        />
                                    </div>

                                    <h5 style={{ 
                                        fontSize: '1.125rem', 
                                        fontWeight: '600',
                                        color: '#262A33',
                                        marginBottom: '12px',
                                        marginTop: '16px'
                                    }}>
                                        {feature.title}
                                    </h5>

                                    <p style={{ 
                                        fontSize: '0.95rem', 
                                        color: '#6B7280',
                                        lineHeight: '1.6',
                                        marginBottom: '0'
                                    }}>
                                        {feature.description}
                                    </p>
                                </div>
                            </Col>
                        );
                    })}
                </Row>
            </Container>
        </Container>
    );
}

export default PackageFeatures;
